import { Button } from '@cdl/heartbeat-react';
import { parseLeadName } from '../utils/lead';

interface Props {
  lead: string;
  selected?: boolean;
  onSelect: () => void;
  onToggle: () => void;
}

export const LeadButton: React.FC<Props> = ({
  lead,
  selected = false,
  onSelect,
  onToggle,
}) => {
  return (
    <Button
      variant='tertiary'
      size='xs'
      isActive={selected}
      px='xs'
      fontSize='s'
      minWidth='1.25rem'
      onClick={({ metaKey, ctrlKey }) =>
        metaKey || ctrlKey ? onToggle() : onSelect()
      }
    >
      {parseLeadName(lead)}
    </Button>
  );
};
